import { TableCell, Avatar } from '@mui/material';

const IMG_PREFIX =
  'https://storage.uk.cloud.ovh.net/v1/AUTH_948ebf6d457f4ea4802e51b22bfce599/mcpe-assets/';

export default function ImageCell({ imgs }) {
  const firstImg = Array.isArray(imgs) && imgs.length > 0 ? IMG_PREFIX + imgs[0] : null;

  return (
    <TableCell>
      {firstImg ? (
        <Avatar src={firstImg} variant="rounded" sx={{ width: 128, height: 128 }} />
      ) : (
        <Avatar variant="rounded" sx={{ width: 56, height: 56 }}>
          ?
        </Avatar>
      )}
    </TableCell>
  );
}